import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Subscription } from 'rxjs';
import { RouterModule, Router, ActivatedRoute, ParamMap } from '@angular/router';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { FormControl, FormGroup } from '@angular/forms';

declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-usermanagement',
  templateUrl: './usermanagement.component.html',
  styleUrls: ['./usermanagement.component.css']
})
export class UsermanagementComponent {
  userData: Array<any>[];
  successToast: boolean = false;
  successUpdateTile: any;
  public selectControl = new FormControl();
  public oLogin: any = {};
  successUpdate: boolean;
  successRegister: boolean;
  userider: number;
  disablebtn: boolean;
  erroremail: any;
  controlGroups = '-1';
  public subscription: Subscription;
  public errorMessage: false;
  public errormail: any;
  public errorfirstname: boolean = false;
  public errorlastname: boolean = false;
  public errorPassword: boolean = false;
  public passworderror: boolean = false;
  public errorConfirmPassword: boolean = false;
  public errorControl: boolean = false;
  public errorReport: boolean = false;
  public deletingtext: boolean = false;
  public updatingtext: boolean = false;
  paginationData: any = {};
  popupData:any = [];
  currentPage: 1;

  constructor(public auth: AuthService, private route: ActivatedRoute,
    private router: Router) { }

  // onload get controlled data
  ngOnInit() {
    this.getUser();
  }
  getUser(page = 0) {
    let data = {
      "pageNo": page,
      "pageSize": 10
    }
    this.auth.getUsers(data).subscribe(res => {
      this.userData = res.userList.map((e: any) => {
        let _a:any = [];
        Object.keys(e.reportAccess).forEach(ele => {
          _a = _a.concat(e.reportAccess[ele])
        })
        e.reportAccess = _a;
        return e;
      });
      res.paginationDetails.currentPage = res.paginationDetails.currentPage + 1
      this.paginationData = res.paginationDetails
    })
  }

  deleteUser(): void {
    this.deletingtext = true;
    this.auth.deleteUser(this.userider).subscribe(data => {
      let status = data.status;
      this.getUser();
      this.deletingtext = false;
      $('#hidemodal3').modal('hide');
    })
  }

  openEdit(user:any) {
    this.router.navigate([`/reporting/inviteuser/update/${user.userId}`]);
 }
  openDelete(user: any) {
    this.userider = user.userId;
  }
  
  resend(user: any){
        this.userider = user.userId;
        this.auth.resend(this.userider).subscribe(res => {
          this.successUpdateTile = res.details;
          this.successToast = true;
          setTimeout(() => {
           this.successToast = false;
       }, 5000);  
       })
    }
    onChangeTable(page:any): any {
      this.getUser(page.page-1)
  }
  onClickCg(data:any){
    this.currentPage = 1;
    this.popupData = data;
    $('#popModal').modal('show');
  }
  changePage = (index: any) => {
    this.currentPage = index;
  };
}



// WEBPACK FOOTER //
// ./src/app/usermanagement/usermanagement.component.ts